import React, { useEffect, useState } from 'react';
import "./hotjarPopup.scss";

const HOTJAR_ID = '6467845';
const HOTJAR_VERSION = 6;

const HotjarPopup = () => {
    const [visible, setVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('hotjarConsentPrideMx');

        if (consent === 'rejected') {
            removeHotjarScript();
            return;
        }

        loadHotjar();

        if (consent === null) {
            setShouldRender(true);
            setTimeout(() => setVisible(true), 50);
        }
    }, []);

    const loadHotjar = () => {
        if (window.hj) return;

        if(window.location.hostname === "pridemx.com") {
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid: HOTJAR_ID, hjsv: HOTJAR_VERSION};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');
                r.async = true;
                r.id = 'hotjar-script';
                r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        }
    };

    const removeHotjarScript = () => {
        const script = document.getElementById('hotjar-script');
        if (script && script.parentNode) {
            script.parentNode.removeChild(script);
        }
        delete window.hj;
        delete window._hjSettings;
    };

    const closePopup = () => {
        setVisible(false); // fade-out
        setTimeout(() => setShouldRender(false), 300);
    };

    const handleAccept = () => {
        localStorage.setItem('hotjarConsentPrideMx', 'accepted');
        closePopup();
    };

    const handleReject = () => {
        localStorage.setItem('hotjarConsentPrideMx', 'rejected');
        removeHotjarScript();
        closePopup();
    };

    if (!shouldRender) return null;

    return (
        <div className={`popup-container ${visible ? 'fade-in' : 'fade-out'}`}>
            <p>
                Utilizamos cookies para mejorar su experiencia de navegación y analizar nuestro tráfico.
                <br />
                Al hacer clic en <strong>«Aceptar»</strong>, aceptas el uso que hacemos de las cookies.
            </p>
            <div className="popup-container__btns">
                <button onClick={handleReject} className="btn-rejected" type="button">Rechazar</button>
                <button onClick={handleAccept} className="btn-accepted" type="button">Aceptar</button>
            </div>
        </div>
    );
};

export default HotjarPopup;